import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Banners extends Component {
  state = {
    banners: [],
    formData: { 
      id: null, 
      banner_name: "", 
      banner_status: "", 
      banner_img: null,
      banner_url: "" // <-- new field
    },
    imagePreview: "",
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
  };

  componentDidMount() {
    this.fetchbanners();

    const modalEl = document.getElementById("bannerModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.setState({
          formData: { 
            id: null, 
            banner_name: "", 
            banner_status: "", 
            banner_img: null,
            banner_url: "" // reset new field
          },
          imagePreview: "",
          error: "",
          submitting: false,
          modalMode: "add",
        });
      });
    }
  }

  /** Fetch all banners */
  fetchbanners = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const res = await axios.get("/banners");
      const data = res.data?.data || [];
      this.setState({ banners: Array.isArray(data) ? data : [] });
    } catch (err) {
      this.setState({
        error: err.response?.data?.message || "Failed to load banners.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  /** Handle input field changes */
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
    }));
  };

  /** Handle file input change */
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState((prev) => ({
        formData: { ...prev.formData, banner_img: file },
        imagePreview: URL.createObjectURL(file),
      }));
    }
  };

  /** Open modal (add or edit) */
  openModal = (mode = "add", banner = null) => {
    const modal = new window.bootstrap.Modal(document.getElementById("bannerModal"));
    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    if (mode === "edit" && banner) {
      this.setState({
        modalMode: "edit",
        formData: {
          id: banner.id,
          banner_name: banner.banner_name,
          banner_status: banner.banner_status?.toString() ?? "1",
          banner_img: null,
          banner_url: banner.banner_url || "" // populate new field
        },
        imagePreview: banner.banner_img
          ? `${baseUrl}/uploads/banners/${banner.banner_img}`
          : "",
        error: "",
      });
    } else {
      this.setState({
        modalMode: "add",
        formData: { 
          id: null, 
          banner_name: "", 
          banner_status: "", 
          banner_img: null,
          banner_url: "" 
        },
        imagePreview: "",
        error: "",
      });
    }

    modal.show();
  };

  /** Submit form (add or update) */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.banner_name) {
      return this.setState({ error: "banner name is required." });
    }

    if (formData.banner_status === "") {
      return this.setState({ error: "banner status is required." });
    }

    const data = new FormData();
    data.append("banner_name", formData.banner_name);
    data.append("banner_status", formData.banner_status);
    data.append("banner_url", formData.banner_url); // append new field
    if (formData.banner_img) data.append("banner_img", formData.banner_img);

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");

      if (modalMode === "add") {
        await axios.post("/banners", data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.post(`/banners/${formData.id}?_method=PUT`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      await this.fetchbanners();

      const modal = window.bootstrap.Modal.getInstance(document.getElementById("bannerModal"));
      modal.hide();

      Swal.fire({
        icon: "success",
        title:
          modalMode === "add"
            ? "banner added successfully!"
            : "banner updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Error saving banner.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  /** Confirm delete popup */
  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(document.getElementById("deleteModal"));
    modal.show();
  };

  /** Delete banner */
  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      await axios.delete(`/banners/${deleteId}`);
      await this.fetchbanners();

      const modal = window.bootstrap.Modal.getInstance(document.getElementById("deleteModal"));
      modal.hide();

      Swal.fire({
        icon: "success",
        title: "banner deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch {
      Swal.fire({
        icon: "error",
        title: "Failed to delete banner.",
      });
    }
  };

  render() {
    const { banners, formData, imagePreview, error, loading, submitting, modalMode } = this.state;
    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Banner</li>
                    <li className="breadcrumb-item active">List</li>
                  </ul>
                  <button
                    type="button"
                    className="btn btn-light-warning"
                    onClick={() => this.openModal("add")}
                  >
                    + New Banner
                  </button>
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>URL</th> {/* new column */}
                            <th>Image</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {banners.length ? (
                            banners.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.banner_name}</td>
                                <td>{item.banner_url || "-"}</td> {/* show new field */}
                                <td>
                                  {item.banner_img ? (
                                    <img
                                      src={`${baseUrl}/uploads/banners/${item.banner_img}`}
                                      alt="img"
                                      style={{ width: "50px", height: "50px", borderRadius: "6px" }}
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                                <td>
                                  {item.banner_status === "1" || item.banner_status === 1 ? (
                                    <span className="badge bg-success">Active</span>
                                  ) : (
                                    <span className="badge bg-danger">Inactive</span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() => this.openModal("edit", item)}
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>
                                  <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() => this.confirmDelete(item.id)}
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No banners found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add/Edit Modal */}
        <div className="modal fade" id="bannerModal" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalMode === "add" ? "Add Banner" : "Edit Banner"}
                  </h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Banner Name</label>
                    <input
                      type="text"
                      name="banner_name"
                      className="form-control"
                      value={formData.banner_name}
                      onChange={this.handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Banner URL</label> {/* new field */}
                    <input
                      type="text"
                      name="banner_url"
                      className="form-control"
                      value={formData.banner_url}
                      onChange={this.handleChange}
                      placeholder="https://example.com"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Banner Status</label>
                    <select
                      name="banner_status"
                      className="form-select"
                      value={formData.banner_status}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select Status</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Banner Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={this.handleFileChange}
                    />
                    {imagePreview && (
                      <div className="mt-2 text-center">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ width: "100px", borderRadius: "8px" }}
                        />
                      </div>
                    )}
                  </div>

                  {error && <div className="alert alert-danger">{error}</div>}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-light-primary"
                    disabled={submitting}
                  >
                    {submitting
                      ? "Saving..."
                      : modalMode === "add"
                      ? "Add"
                      : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Delete Confirmation */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <i className="ph ph-warning text-danger f-40 mb-3"></i>
                <h5>Are you sure?</h5>
                <p className="text-muted mb-4">This action cannot be undone.</p>
                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-light-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    onClick={this.handleDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Banners;
